package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Visibility
import fyi.moko.hotpl.domain.repository.PlaceRepository

/**
 * Sets a saved place's [Visibility] (detail screen share control). Implemented via
 * plain read-modify-write through [PlaceRepository.savePlace] — same shape as
 * [ToggleLikedUseCase] — so it picks up `savePlace`'s existing version bump /
 * `PENDING_UPSERT` / sync_queue enqueue for free. [fyi.moko.hotpl.data.service.SyncCoordinator]
 * already projects any non-PRIVATE place to `/public_places` on push; no sync changes needed.
 */
class SetPlaceVisibilityUseCase(
    private val repository: PlaceRepository,
) {
    suspend operator fun invoke(placeId: String, visibility: Visibility) {
        val place = repository.getPlace(placeId) ?: return
        repository.savePlace(place.copy(visibility = visibility))
    }
}
